import { useEffect, useMemo, useRef, useState } from "react";
import { parseGIF, decompressFrames } from "gifuct-js";
import { Button } from "react-bootstrap";
import PauseIcon from "../../../../../components/svgs/PauseIcon";
import Play from "../../../../../components/Icons/Play";
import PlayIcon from "../../../../../components/svgs/PlayIcon";
import ReloadIcon from "../../../../../components/Icons/RealodIcon";

function dataUrlToArrayBuffer(dataUrl) {
    const base64 = dataUrl.split(",")[1];
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes.buffer;
}

const GifPlay = ({ src }) => {
    const canvasRef = useRef(null);
    const timerRef = useRef(null);

    const [frames, setFrames] = useState([]);
    const [currentFrame, setCurrentFrame] = useState(0);
    const [isPlaying, setIsPlaying] = useState(true);
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!src) return;

        try {
            const buffer = dataUrlToArrayBuffer(src);
            const gif = parseGIF(buffer);
            const gifFrames = decompressFrames(gif, true);

            const width = Math.max(
                ...gifFrames.map((f) => f.dims.left + f.dims.width)
            );

            const height = Math.max(
                ...gifFrames.map((f) => f.dims.top + f.dims.height)
            );

            setFrames(gifFrames);
            setCanvasSize({ width, height });
            setCurrentFrame(0);
            setIsPlaying(true);
        } catch (error) {
            console.error("Error al parsear GIF:", error);
        }
    }, [src]);

    const renderUpToFrame = (targetFrameIndex) => {
        const canvas = canvasRef.current;
        if (!canvas || !frames.length) return;

        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i <= targetFrameIndex; i++) {
            const frame = frames[i];
            const imageData = new ImageData(
                frame.patch,
                frame.dims.width,
                frame.dims.height
            );

            ctx.putImageData(imageData, frame.dims.left, frame.dims.top);
        }
    };

    useEffect(() => {
        if (!frames.length) return;
        renderUpToFrame(currentFrame);
    }, [currentFrame, frames]);

    useEffect(() => {
        if (!isPlaying || !frames.length) return;

        const delay = Math.max(frames[currentFrame]?.delay || 100, 30);

        timerRef.current = setTimeout(() => {
            setCurrentFrame((prev) => {
                const next = prev + 1;
                return next >= frames.length ? 0 : next; // loop infinito
            });
        }, delay);

        return () => clearTimeout(timerRef.current);
    }, [isPlaying, currentFrame, frames]);

    const handleRestart = () => {
        setCurrentFrame(0);
        setIsPlaying(true);
    };

    return (
        <div className="w-100 d-flex flex-column gap-2 align-items-center">
            <canvas
                ref={canvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "contain",
                    background: "#00000010",
                }}
            />

            <div className="d-flex gap-2 align-items-center w-100 p-2 px-4">
                <div className="cursor-pointer "
                    onClick={() => setIsPlaying((prev) => !prev)}>
                    {
                        isPlaying
                            ?
                            <PauseIcon color="#fff" />
                            :
                            <PlayIcon color="#fff" />
                    }
                </div>

                <div onClick={handleRestart}>
                    <ReloadIcon width color={'#fff'} />
                </div>

                <input
                    type="range"
                    min={0}
                    max={Math.max(frames.length - 1, 0)}
                    value={currentFrame}
                    onChange={(e) => {
                        setCurrentFrame(Number(e.target.value));
                        setIsPlaying(false);
                    }}
                    style={{ flex: 1 }}
                />
            </div>
        </div>
    );
};

export default GifPlay;